export default __webpack_public_path__ + "static/media/SignupCarouselSS3.4833dc27.svg";